import React, { useEffect, useRef } from "react";

const RecommendationsList = ({
  recommendations,
  handleRecommendationClick,
  highlightedIndex,
  setHighlightedIndex,
  setIsVisible,
  renderField = (item) => item,
}) => {
  const listRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsVisible]);

  useEffect(() => {
    if (listRef.current && highlightedIndex !== null) {
      const listItem = listRef.current.children[highlightedIndex];
      if (listItem) {
        const { offsetTop, clientHeight } = listItem;
        const { scrollTop, clientHeight: listHeight } = listRef.current;

        if (offsetTop < scrollTop) {
          listRef.current.scrollTop = offsetTop;
        } else if (offsetTop + clientHeight > scrollTop + listHeight) {
          listRef.current.scrollTop = offsetTop - listHeight + clientHeight;
        }
      }
    }
  }, [recommendations, highlightedIndex]);

  if (recommendations.length === 0) {
    return null;
  }

  return (
    <ul
      ref={listRef}
      className="absolute -left-3 w-[130%] max-h-96 overflow-auto mt-2 bg-white border-2 border-quinary rounded-lg shadow-lg z-30 divide-y-2 divide-[#00000014]"
    >
      {recommendations.map((recommendation, index) => (
        <li
          key={index}
          className={`px-4 py-2 hover:bg-quinary hover:text-white cursor-pointer text-sm font-medium ${
            index === highlightedIndex ? "bg-quinary text-white" : ""
          }`}
          onClick={() => {
            handleRecommendationClick(recommendation);
            setIsVisible(false);
          }}
          onMouseEnter={() => setHighlightedIndex(index)}
        >
          {renderField(recommendation)}
        </li>
      ))}
    </ul>
  );
};

export default RecommendationsList;
